var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 22.4983C19 22.4983 22.4983 17.7977 22.4983 11.9992C22.4983 6.20064 19 1.5 11.9992 1.5C4.99833 1.5 1.5 6.20064 1.5 11.9992C1.5 17.7977 4.99833 22.4983 11.9992 22.4983Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0854 11.3292C10.4559 11.5144 10.6061 11.9649 10.4208 12.3354C9.87927 13.4185 8.77914 13.9894 7.72805 14.141C6.68668 14.2912 5.49746 14.0581 4.71967 13.2803C4.42678 12.9874 4.42678 12.5125 4.71967 12.2197C5.01256 11.9268 5.48744 11.9268 5.78033 12.2197C6.12754 12.5669 6.78711 12.7612 7.5139 12.6563C8.23096 12.5529 8.81833 12.1863 9.07918 11.6646C9.26442 11.2941 9.71493 11.1439 10.0854 11.3292Z",
    fill: "#402A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9146 11.3292C13.5441 11.5144 13.3939 11.9649 13.5792 12.3354C14.1207 13.4185 15.2209 13.9894 16.272 14.141C17.3133 14.2912 18.5025 14.0581 19.2803 13.2803C19.5732 12.9874 19.5732 12.5125 19.2803 12.2197C18.9874 11.9268 18.5126 11.9268 18.2197 12.2197C17.8725 12.5669 17.2129 12.7612 16.4861 12.6563C15.769 12.5529 15.1817 12.1863 14.9208 11.6646C14.7356 11.2941 14.2851 11.1439 13.9146 11.3292Z",
    fill: "#402A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81884 18.5444C10.5744 16.7824 13.4228 16.7763 15.1842 18.5248C15.4781 18.8166 15.953 18.8149 16.2448 18.5209C16.5366 18.2269 16.5349 17.7521 16.2409 17.4602C13.8923 15.1288 10.0957 15.1377 7.75624 17.4857C7.46388 17.7791 7.46475 18.254 7.75818 18.5463C8.05161 18.8387 8.52648 18.8378 8.81884 18.5444Z",
    fill: "#402A32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.35144eb8.svg";
export { ForwardRef as ReactComponent };